import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import JobtitleDrawer from "components/drawer/JobtitleDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import ShowActive from "components/table/ShowActive";
import EditDeleteButton from "components/table/EditDeleteButton";
import Tooltip from "components/tooltip/Tooltip";
import useToggleDrawer from "hooks/useToggleDrawer";
import React, { useContext } from "react";
import ViewModal from "components/modal/ViewJobdetails";
import { SidebarContext } from "context/SidebarContext";
import { FiEye } from "react-icons/fi";

import { notifyError, notifySuccess } from "utils/toast";
import JobtitleServices from "services/JobtitleServices";
// internal imports


const JobtitleTable = ({ jobtitle, perpage, currentPage, tab,hideEdit,hideDelete }) => {

  const { title, serviceId, handleJobDetails, handleModalOpen, handleUpdate } =
    useToggleDrawer();

  const { setIsUpdate } = useContext(SidebarContext);

  const handleActive = async (id, currentStatus, titleActive) => {
    const newStatus = currentStatus === 1 ? 0 : 1;
    try {
      const response = await JobtitleServices.updateActiveStatus(id, {
        status: newStatus,
      });
      if (response.status) {
        notifySuccess(`Status Updated Successfully`);
        setIsUpdate(true);
      } else {
        notifyError("Failed to update status");
      }
    } catch (error) {
      notifyError("An error occurred while updating status");
      console.error(error);
    }
  };

  return (
    <>
      <ViewModal id={serviceId} title={title} data={jobtitle} />
      <DeleteModal id={serviceId} title={title} />

      <MainDrawer>
        <JobtitleDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
        {jobtitle?.slice(0, perpage).map((data, index) => (
          <TableRow key={data.id}>
            <TableCell className="font-semibold text-xs text-center">
              <span>{(currentPage - 1) * perpage + index + 1}</span>
            </TableCell>

            <TableCell className="text-center text-sm">
              <span>{data.job_roles}</span>
            </TableCell>

            <TableCell className="text-center">
              <ShowActive
                id={data.id}
                active={data.is_active}
                title_active={"Active"}
                handleActive={handleActive}
              />
            </TableCell>

            <TableCell>
              <div className="flex justify-center items-center">
                <button
                  onClick={() => handleJobDetails(data.id, "Job Details")}
                  className="p-2 cursor-pointer text-gray-400 hover:text-red-600 focus:outline-none"
                >
                  <Tooltip
                    id={data.id}
                    Icon={FiEye}
                    title="ViewOrder"
                    bgColor="#34D399"
                  />
                </button>
                <EditDeleteButton
                  title={data.name}
                  id={data.id}
                  handleUpdate={handleUpdate}
                  handleModalOpen={handleModalOpen}
                  hideEdit={hideEdit}
                  hideDelete={hideDelete}
                />
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default JobtitleTable;
